import { Union } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { union_type, list_type, bool_type, int32_type, lambda_type, unit_type, class_type, string_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { CSSProp_$reflection } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { toProps } from "../React.fs.js";
import * as react from "react";
import { CaretDownOutlined as CaretDownOutlined_1, CaretUpOutlined as CaretUpOutlined_1, EyeFilled as EyeFilled_1, StarOutlined as StarOutlined_1, LinkOutlined as LinkOutlined_1, ClockCircleFilled as ClockCircleFilled_1, FireFilled as FireFilled_1, PushpinFilled as PushpinFilled_1, PushpinOutlined as PushpinOutlined_1, RiseOutlined as RiseOutlined_1, PlusCircleFilled as PlusCircleFilled_1, UserOutlined as UserOutlined_1, HolderOutlined as HolderOutlined_1, FlagOutlined as FlagOutlined_1, ShoppingOutlined as ShoppingOutlined_1, MenuUnfoldOutlined as MenuUnfoldOutlined_1, MenuFoldOutlined as MenuFoldOutlined_1, SaveFilled as SaveFilled_1, HighlightOutlined as HighlightOutlined_1, NodeIndexOutlined as NodeIndexOutlined_1, PauseCircleFilled as PauseCircleFilled_1, ExportOutlined as ExportOutlined_1, DisconnectOutlined as DisconnectOutlined_1, BulbFilled as BulbFilled_1, UnorderedListOutlined as UnorderedListOutlined_1, ControlOutlined as ControlOutlined_1, DeleteFilled as DeleteFilled_1, EditFilled as EditFilled_1, PlusOutlined as PlusOutlined_1, PartitionOutlined as PartitionOutlined_1, SwitcherFilled as SwitcherFilled_1, QuestionCircleFilled as QuestionCircleFilled_1, ArrowLeftOutlined as ArrowLeftOutlined_1, CalendarOutlined as CalendarOutlined_1, CloseCircleFilled as CloseCircleFilled_1, CloseOutlined as CloseOutlined_1, ExclamationCircleFilled as ExclamationCircleFilled_1, InfoCircleFilled as InfoCircleFilled_1, InfoCircleOutlined as InfoCircleOutlined_1, CheckCircleFilled as CheckCircleFilled_1, DownOutlined as DownOutlined_1, UpOutlined as UpOutlined_1, RightOutlined as RightOutlined_1, LeftOutlined as LeftOutlined_1, CaretDownFilled as CaretDownFilled_1, CaretUpFilled as CaretUpFilled_1, LoadingOutlined as LoadingOutlined_1, LineChartOutlined as LineChartOutlined_1, GlobalOutlined as GlobalOutlined_1, SearchOutlined as SearchOutlined_1, LogoutOutlined as LogoutOutlined_1, FileProtectOutlined as FileProtectOutlined_1, SettingFilled as SettingFilled_1, SettingOutlined as SettingOutlined_1, SolutionOutlined as SolutionOutlined_1, LockFilled as LockFilled_1, BarsOutlined as BarsOutlined_1, CompassOutlined as CompassOutlined_1, DashboardOutlined as DashboardOutlined_1 } from "@ant-design/icons";

export class IconProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ClassName", "OnClick", "Rotate", "Spin", "Style", "TwoToneColor", "Key"];
    }
}

export function IconProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Interop.Antd.Icon.IconProps", [], IconProps, () => [[["Item", string_type]], [["Item", lambda_type(class_type("Browser.Types.Event", undefined), unit_type)]], [["Item", int32_type]], [["Item", bool_type]], [["Item", list_type(CSSProp_$reflection())]], [["Item", string_type]], [["Item", string_type]]]);
}

export function DashboardOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(DashboardOutlined_1, props_1, ...elems);
}

export function CompassOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CompassOutlined_1, props_1, ...elems);
}

export function BarsOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(BarsOutlined_1, props_1, ...elems);
}

export function LockFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LockFilled_1, props_1, ...elems);
}

export function SolutionOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SolutionOutlined_1, props_1, ...elems);
}

export function SettingOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SettingOutlined_1, props_1, ...elems);
}

export function SettingFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SettingFilled_1, props_1, ...elems);
}

export function FileProtectOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(FileProtectOutlined_1, props_1, ...elems);
}

export function LogoutOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LogoutOutlined_1, props_1, ...elems);
}

export function SearchOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SearchOutlined_1, props_1, ...elems);
}

export function GlobalOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(GlobalOutlined_1, props_1, ...elems);
}

export function LineChartOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LineChartOutlined_1, props_1, ...elems);
}

export function LoadingOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LoadingOutlined_1, props_1, ...elems);
}

export function CaretUpFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CaretUpFilled_1, props_1, ...elems);
}

export function CaretDownFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CaretDownFilled_1, props_1, ...elems);
}

export function LeftOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LeftOutlined_1, props_1, ...elems);
}

export function RightOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(RightOutlined_1, props_1, ...elems);
}

export function UpOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(UpOutlined_1, props_1, ...elems);
}

export function DownOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(DownOutlined_1, props_1, ...elems);
}

export function CheckCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CheckCircleFilled_1, props_1, ...elems);
}

export function InfoCircleOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(InfoCircleOutlined_1, props_1, ...elems);
}

export function InfoCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(InfoCircleFilled_1, props_1, ...elems);
}

export function ExclamationCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ExclamationCircleFilled_1, props_1, ...elems);
}

export function CloseOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CloseOutlined_1, props_1, ...elems);
}

export function CloseCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CloseCircleFilled_1, props_1, ...elems);
}

export function CalendarOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CalendarOutlined_1, props_1, ...elems);
}

export function ArrowLeftOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ArrowLeftOutlined_1, props_1, ...elems);
}

export function QuestionCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(QuestionCircleFilled_1, props_1, ...elems);
}

export function SwitcherFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SwitcherFilled_1, props_1, ...elems);
}

export function PartitionOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PartitionOutlined_1, props_1, ...elems);
}

export function PlusOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PlusOutlined_1, props_1, ...elems);
}

export function EditFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(EditFilled_1, props_1, ...elems);
}

export function DeleteFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(DeleteFilled_1, props_1, ...elems);
}

export function ControlOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ControlOutlined_1, props_1, ...elems);
}

export function UnorderedListOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(UnorderedListOutlined_1, props_1, ...elems);
}

export function BulbFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(BulbFilled_1, props_1, ...elems);
}

export function DisconnectOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(DisconnectOutlined_1, props_1, ...elems);
}

export function ExportOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ExportOutlined_1, props_1, ...elems);
}

export function PauseCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PauseCircleFilled_1, props_1, ...elems);
}

export function NodeIndexOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(NodeIndexOutlined_1, props_1, ...elems);
}

export function HighlightOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(HighlightOutlined_1, props_1, ...elems);
}

export function SaveFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(SaveFilled_1, props_1, ...elems);
}

export function MenuFoldOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(MenuFoldOutlined_1, props_1, ...elems);
}

export function MenuUnfoldOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(MenuUnfoldOutlined_1, props_1, ...elems);
}

export function ShoppingOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ShoppingOutlined_1, props_1, ...elems);
}

export function FlagOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(FlagOutlined_1, props_1, ...elems);
}

export function HolderOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(HolderOutlined_1, props_1, ...elems);
}

export function UserOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(UserOutlined_1, props_1, ...elems);
}

export function PlusCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PlusCircleFilled_1, props_1, ...elems);
}

export function RiseOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(RiseOutlined_1, props_1, ...elems);
}

export function PushpinOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PushpinOutlined_1, props_1, ...elems);
}

export function PushpinFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(PushpinFilled_1, props_1, ...elems);
}

export function FireFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(FireFilled_1, props_1, ...elems);
}

export function ClockCircleFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(ClockCircleFilled_1, props_1, ...elems);
}

export function LinkOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(LinkOutlined_1, props_1, ...elems);
}

export function StarOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(StarOutlined_1, props_1, ...elems);
}

export function EyeFilled(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(EyeFilled_1, props_1, ...elems);
}

export function CaretUpOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CaretUpOutlined_1, props_1, ...elems);
}

export function CaretDownOutlined(props, elems) {
    const props_1 = toProps(props);
    return react.createElement(CaretDownOutlined_1, props_1, ...elems);
}

